/**
 * @generated SignedSource<<c8ef87bdc83775834fd18d28e9a5953a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleVariant_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModule_viewer";
};
export type HpSharedFeaturedModule_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSaleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_viewer",
  "selections": [
    {
      "condition": "isSaleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleVariant_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cd6ae25b79027b6de5cc3730c5fbe6c0";

export default node;
